import type { FC } from "react";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { AppPage } from "../layout/AppLayout";
import { MetaAdsRoleManager } from "./MetaAdsRoleManager";
import { useCanManageMetaAdsRoles } from "./useMyMetaAdsRole";

const TeamContent: FC = () => {
	const canManage = useCanManageMetaAdsRoles();

	if (!canManage) {
		return (
			<p className="text-muted">
				Only Meta Ads Managers (and the company owner) can manage team roles.
			</p>
		);
	}

	return <MetaAdsRoleManager />;
};

export const PageMetaAdsTeam: FC = () => {
	return (
		<AppPage title="Meta Ads Team">
			<div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
				<p className="text-muted" style={{ marginBottom: 0 }}>
					Assign Meta Ads roles to team members. The company owner always has
					Manager access. Changes take effect immediately.
				</p>
				<ErrorBoundary
					fallback={
						<p className="text-muted">
							Unable to load role management. You may not have Manager access.
						</p>
					}
				>
					<Suspense fallback={<p>Loading...</p>}>
						<TeamContent />
					</Suspense>
				</ErrorBoundary>
			</div>
		</AppPage>
	);
};
